import React from "react";

import Header from "../../contruction-home/components/Header";
import Footer from "../../contruction-home/components/Footer";
import Hero from "../../contruction-home/components/Hero";
import Projects from "../../contruction-home/components/Projects";
import NormalUserLayout from "../../layouts/NormalUserLayout/NormalUserLayout";

const References = () => {
  return (
    <div className="ConstructionHome">
      <NormalUserLayout>
        <Header />
        <main className="main">
          {/* <div style={{ background: "rgba(0, 0, 0, 1)" }}> */}
          <Hero compact />
          <Projects />
        </main>
        <Footer />
      </NormalUserLayout>
    </div>
  );
};

export default References;
